export enum AdjustmentType {
  Void = 'V',
}
